/** Valor persistido quando o organizador não quer tag de categoria na página pública. */
export const UNCATEGORIZED_EVENT_CATEGORY = 'none';

export function shouldShowEventCategoryTag(category?: string | null): boolean {
  const value = String(category || '').trim().toLowerCase();
  return Boolean(value) && value !== UNCATEGORIZED_EVENT_CATEGORY;
}
